import React, { useState } from "react";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { TabPanel, useTabStyle } from "App/Component/ui";
import {
  TabBed,
  TabKelasKamar,
  TabRuang,
  TabGolonganKelas,
  TabKelasKamarSirsOnline,
  TabKamar,
  // TabRuangRsOL
} from "./ui";
import TabRuangAplicares from "./ui/TabRuangAplicares/TabRuangAplicares";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export default function Bed() {
  const classes = useTabStyle();

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div
      className={classes.root}
      style={{
        marginTop: "1rem",
      }}>
      <div className={classes.rootTab}>
        <AppBar
          position='static'
          classes={{
            root: classes.appbar,
          }}
          style={{ height: "auto" }}
          >
          <Tabs
            variant='fullWidth'
            centered={false}
            value={value}
            onChange={handleChange}
            aria-label='Tabs Bed'
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: false,
              }}
              label='BED'
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='KLS KAMAR'
              {...a11yProps(1)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RUANG'
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='KAMAR'
              {...a11yProps(3)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='GOL KLS APLICARES'
              {...a11yProps(4)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RUANG APLICARES & RS OL'
              {...a11yProps(5)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              // label='KLS KMR SIRS OL'
              label='GOL KLS RS OL'
              {...a11yProps(6)}
            />
            {/* <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RUANG RS OL'
              {...a11yProps(7)}
            /> */}
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <TabBed />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TabKelasKamar />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <TabRuang />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <TabKamar />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <TabGolonganKelas />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <TabRuangAplicares />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <TabKelasKamarSirsOnline />
        </TabPanel>
        {/* <TabPanel value={value} index={7}>
          <TabRuangRsOL/>
        </TabPanel> */}
      </div>
    </div>
  );
}
